import { useEffect } from "react";
import termsContent from "../../data/termsContent";

const Terms = () => {
    useEffect(() => {
        document.title = "AGB | Casaantonio e piccolo gió";
    }, []);
    return (
        <main className="terms">
            <h2>Allgemeine Geschäftsbedingungen</h2>
            <p>Willkommen bei Casaantonio e piccolo gió. Diese Nutzungsbedingungen enthalten die Regeln und Richtlinien für die Nutzung unserer Website und Dienstleistungen. Durch den Zugriff auf unsere Website oder deren Nutzung erklären Sie sich mit diesen Bedingungen einverstanden. Bitte lesen Sie sie sorgfältig durch, bevor Sie fortfahren.</p>
            {termsContent.map((content) =>
                <section key={content.title}>
                    <h3>{content.id}. {content.title}:</h3>
                    <p>{content.content}</p>
                </section>)}
        </main>
    )
}

export default Terms;